import React from 'react';

import { getConfig } from '@edx/frontend-platform';
import { useIntl } from '@edx/frontend-platform/i18n';
import classNames from 'classnames';

const MediumLayout = () => {
  const { formatMessage } = useIntl();

  return (
    <div className="login-background w-100">
      {/* <Hyperlink destination={getConfig().MARKETING_SITE_BASE_URL}>
        <Image
          alt={getConfig().SITE_NAME}
          className="logo"
          src={getConfig().LOGO_WHITE_URL}
        />
      </Hyperlink> */}
      <div className="d-flex align-items-center justify-content-center mb-4 ">
        <div
          className={classNames({
            'mt-1 medium-yellow-line': getConfig().SITE_NAME === 'edX',
          })}
        />
        <div>
          {/* <h1
            className={classNames(
              'display-1 text-white mt-5 mb-5 mr-2 main-heading',
              // eslint-disable-next-line comma-dangle
              { 'ml-4.5': getConfig().SITE_NAME !== 'edX' }
            )}
          >
            <span>
              {formatMessage(messages['start.learning'])}{' '}
              <span className="text-accent-a d-inline-block">
                {formatMessage(messages['with.site.name'], {
                  siteName: getConfig().SITE_NAME,
                })}
              </span>
            </span>
          </h1> */}
        </div>
      </div>
    </div>
  );
};

export default MediumLayout;
